function mapPages(cache, mapPage) {
  if (!cache?.pages) return cache;
  return { ...cache, pages: cache.pages.map(mapPage) };
}

function decrement(value, amount) {
  return typeof value === "number" ? Math.max(0, value - amount) : value;
}

function countMatches(items, notificationId) {
  return (items ?? []).filter((item) => item?.id === notificationId).length;
}

function withoutId(items, notificationId) {
  return (items ?? []).filter((item) => item?.id !== notificationId);
}

export const removeNotification = (notificationId) => (cache) =>
  mapPages(cache, (page) => {
    const removedUnread = countMatches(page.unreadItems, notificationId);
    const removedRead = countMatches(page.readItems, notificationId);
    const removedTotal = removedUnread + removedRead;

    if (removedTotal === 0) return page;

    return {
      ...page,
      unreadItems: withoutId(page.unreadItems, notificationId),
      readItems: withoutId(page.readItems, notificationId),
      pagination: {
        ...page.pagination,
        totalCount: decrement(page.pagination?.totalCount, removedTotal),
        totalUnreadCount: decrement(page.pagination?.totalUnreadCount, removedUnread),
      },
    };
  });

export const markAllRead = () => (cache) =>
  mapPages(cache, (page) => ({
    ...page,
    unreadItems: [],
    readItems: [
      ...(page.unreadItems ?? []).map((item) => ({ ...item, is_read: true })),
      ...(page.readItems ?? []),
    ],
    pagination: { ...page.pagination, totalUnreadCount: 0 },
  }));
